import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239c1d1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-outer" }
const _hoisted_2 = { class: "logoff" }
const _hoisted_3 = { class: "box-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: "/logo.svg"
  })
], -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, null, -1))
const _hoisted_7 = { class: "workspaces" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "icon",
    src: "/studiocloud_gradient-SF.png"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "workspace-name" }, "CodAL workspace", -1))
const _hoisted_10 = { class: "workspace-button-box" }
const _hoisted_11 = { class: "workspace-button" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Open")
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.codasip.com/",
  target: "_blank",
  class: "footer-link right"
}, "www.codasip.com", -1))
const _hoisted_18 = { style: {"margin-left":"2.5em","padding":"0 7em 2em 0"} }
const _hoisted_19 = {
  key: 0,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CButton = _resolveComponent("CButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "logoffbutton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, "Log off")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, " Welcome back " + _toDisplayString(_ctx.myuser) + " ! ", 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.availableContainers?.length > 1)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSelectContainer && _ctx.handleSelectContainer(...args))),
                  ref: "selectedContainer",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedContainerV) = $event)),
                  name: "containers",
                  id: "containers",
                  class: "dropdown"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableContainers, (container) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: container,
                      value: container
                    }, _toDisplayString(container), 9, _hoisted_12))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.selectedContainerV]
                ])
              : _createCommentVNode("", true),
            _hoisted_13,
            _createVNode(_component_CButton, {
              type: "button",
              class: "button",
              onClick: _ctx.showModal
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"]),
            _withDirectives(_createVNode(_component_Modal, {
              onReject: _ctx.rejectTerms,
              onAccept: _ctx.acceptTerms
            }, null, 8, ["onReject", "onAccept"]), [
              [_vShow, _ctx.licenceVisible]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("a", {
        href: _ctx.changePasswordUrl,
        class: "footer-link"
      }, "Change Password", 8, _hoisted_16),
      _hoisted_17
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.text), 1),
      (_ctx.showSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19))
        : _createCommentVNode("", true)
    ])
  ]))
}